(function(){
  if (window.__optLanding) return; window.__optLanding = true;
  function pad(n){ return ('0' + n).slice(-2); }
  function tick(){
    var now = new Date(), end = new Date(now); end.setHours(23,59,59,999);
    var d = Math.max(0, end - now);
    var h = Math.floor(d/36e5), m = Math.floor(d%36e5/6e4), s = Math.floor(d%6e4/1e3);
    document.querySelectorAll('[data-opt-cd]').forEach(function(c){
      var a=c.querySelector('[data-h]'),b=c.querySelector('[data-m]'),e=c.querySelector('[data-s]');
      if(a)a.textContent=pad(h); if(b)b.textContent=pad(m); if(e)e.textContent=pad(s);
    });
  }
  function codButton(){
    var sels = ['#_rsi-buy-now-button','[id^="_rsi"] button','button[class*="rsi"]','button[class*="releasit"]','[class*="releasit"] button'];
    for (var i=0;i<sels.length;i++){ var el=document.querySelector(sels[i]); if(el) return el; }
    return null;
  }
  function buy(e){
    if (e) e.preventDefault();
    var btn = codButton();
    var anchor = document.getElementById('opt-buy') || document.querySelector('product-info');
    if (btn) { btn.click(); return; }
    if (anchor) anchor.scrollIntoView({behavior:'smooth', block:'center'});
  }
  function init(){
    tick(); setInterval(tick, 1000);
    document.addEventListener('click', function(e){
      var t = e.target.closest && e.target.closest('.js-opt-buy');
      if (t) buy(e);
    });
    var sticky = document.querySelector('.opt-sticky');
    var anchor = document.getElementById('opt-buy');
    if (sticky && anchor && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
        });
      }).observe(anchor);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
